// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml = require("@rescript/std/lib/js/caml.js");
var Curry = require("@rescript/std/lib/js/curry.js");
var Spice = require("@greenlabs/ppx-spice/src/rescript/Spice.bs.js");
var Belt_Id = require("@rescript/std/lib/js/belt_Id.js");
var Js_json = require("@rescript/std/lib/js/js_json.js");
var Belt_Map = require("@rescript/std/lib/js/belt_Map.js");
var Js_array = require("@rescript/std/lib/js/js_array.js");
var Type_Url = require("./Type_Url.bs.js");
var Js_string = require("@rescript/std/lib/js/js_string.js");
var Belt_Array = require("@rescript/std/lib/js/belt_Array.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Belt_Result = require("@rescript/std/lib/js/belt_Result.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Util_String = require("../util/Util_String.bs.js");
var Type_Pattern = require("./Type_Pattern.bs.js");
var Belt_MutableMap = require("@rescript/std/lib/js/belt_MutableMap.js");
var Js_null_undefined = require("@rescript/std/lib/js/js_null_undefined.js");

var t_encode = Spice.stringToJson;

function t_decode(v) {
  return Belt_Result.map(Spice.stringFromJson(v), (function (v) {
                return v;
              }));
}

var empty = "";

function makeFromNullable(str) {
  return Caml_option.nullable_to_opt(Js_null_undefined.bind(str, (function (str) {
                    return str;
                  })));
}

function makeFromNullableOrEmpty(str) {
  return Belt_Option.getWithDefault(Caml_option.nullable_to_opt(Js_null_undefined.bind(str, (function (str) {
                        return str;
                      }))), "");
}

function String_toString(prim) {
  return prim;
}

function String_make(prim) {
  return prim;
}

var $$String = {
  t_encode: t_encode,
  t_decode: t_decode,
  toString: String_toString,
  empty: empty,
  make: String_make,
  makeFromNullable: makeFromNullable,
  makeFromNullableOrEmpty: makeFromNullableOrEmpty
};

var t_encode$1 = Spice.stringToJson;

var t_decode$1 = Spice.stringFromJson;

function make(str) {
  var trimedStr = str.trim();
  if (Util_String.isNotEmpty(trimedStr)) {
    return trimedStr;
  }
  
}

function toString(t) {
  return t;
}

var NotEmpty = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  toString: toString,
  make: make
};

function Make(T) {
  var cmp = Caml.string_compare;
  var Cmp = Belt_Id.MakeComparable({
        cmp: cmp
      });
  var t_tuple_encode = function (v) {
    return [
            Curry._1(T.Str.t_encode, v[0]),
            Curry._1(T.t_encode, v[1])
          ];
  };
  var t_tuple_decode = function (v) {
    var match = Js_json.classify(v);
    if (typeof match === "number") {
      return Spice.error(undefined, "Not a tuple", v);
    }
    if (match.TAG !== /* JSONArray */3) {
      return Spice.error(undefined, "Not a tuple", v);
    }
    var match$1 = match._0;
    if (match$1.length !== 2) {
      return Spice.error(undefined, "Incorrect cardinality", v);
    }
    var v0 = match$1[0];
    var v1 = match$1[1];
    var match$2 = Curry._1(T.Str.t_decode, v0);
    var match$3 = Curry._1(T.t_decode, v1);
    if (match$2.TAG === /* Ok */0) {
      if (match$3.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: [
                  match$2._0,
                  match$3._0
                ]
              };
      }
      var e = match$3._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: "[1]" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = match$2._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  };
  var t_encode = function (t) {
    return Spice.arrayToJson(t_tuple_encode, Belt_Map.toArray(t));
  };
  var t_decode = function (arr) {
    return Belt_Result.map(Spice.arrayFromJson(t_tuple_decode, arr), (function (param) {
                  return Belt_Map.fromArray(param, Cmp);
                }));
  };
  var fromArray = function (param) {
    return Belt_Map.fromArray(param, Cmp);
  };
  return {
          t_encode: t_encode,
          t_decode: t_decode,
          contains: Belt_Map.has,
          fromArray: fromArray,
          remove: Belt_Map.remove,
          set: Belt_Map.set,
          keys: Belt_Map.keysToArray
        };
}

function MakeMutable(T) {
  var cmp = Caml.string_compare;
  var Cmp = Belt_Id.MakeComparable({
        cmp: cmp
      });
  var key_encode = function (v) {
    return Curry._1(T.Str.t_encode, v);
  };
  var key_decode = function (v) {
    return Curry._1(T.Str.t_decode, v);
  };
  var t_tuple_encode = function (v) {
    return [
            Curry._1(T.Str.t_encode, v[0]),
            Curry._1(T.t_encode, v[1])
          ];
  };
  var t_tuple_decode = function (v) {
    var match = Js_json.classify(v);
    if (typeof match === "number") {
      return Spice.error(undefined, "Not a tuple", v);
    }
    if (match.TAG !== /* JSONArray */3) {
      return Spice.error(undefined, "Not a tuple", v);
    }
    var match$1 = match._0;
    if (match$1.length !== 2) {
      return Spice.error(undefined, "Incorrect cardinality", v);
    }
    var v0 = match$1[0];
    var v1 = match$1[1];
    var match$2 = Curry._1(T.Str.t_decode, v0);
    var match$3 = Curry._1(T.t_decode, v1);
    if (match$2.TAG === /* Ok */0) {
      if (match$3.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: [
                  match$2._0,
                  match$3._0
                ]
              };
      }
      var e = match$3._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: "[1]" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = match$2._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  };
  var t_array_encode = function (v) {
    return Spice.arrayToJson(t_tuple_encode, v);
  };
  var t_array_decode = function (v) {
    return Spice.arrayFromJson(t_tuple_decode, v);
  };
  var InternalType = {
    t_array_encode: t_array_encode,
    t_array_decode: t_array_decode
  };
  var t_encode = function (t) {
    return Spice.arrayToJson(t_tuple_encode, Belt_MutableMap.toArray(t));
  };
  var t_decode = function (arr) {
    return Belt_Result.map(Spice.arrayFromJson(t_tuple_decode, arr), (function (param) {
                  return Belt_MutableMap.fromArray(param, Cmp);
                }));
  };
  var merge = function (t1, t2, f) {
    Belt_MutableMap.forEach(t2, (function (key, value) {
            var newValue = Curry._3(f, key, Belt_MutableMap.get(t1, key), Caml_option.some(value));
            if (newValue !== undefined) {
              return Belt_MutableMap.set(t1, key, Caml_option.valFromOption(newValue));
            } else {
              return Belt_MutableMap.set(t1, key, value);
            }
          }));
  };
  var make = function (param) {
    return Belt_MutableMap.make(Cmp);
  };
  return {
          Cmp: Cmp,
          key_encode: key_encode,
          key_decode: key_decode,
          t_tuple_encode: t_tuple_encode,
          t_tuple_decode: t_tuple_decode,
          InternalType: InternalType,
          t_encode: t_encode,
          t_decode: t_decode,
          get: Belt_MutableMap.get,
          merge: merge,
          remove: Belt_MutableMap.remove,
          set: Belt_MutableMap.set,
          reduce: Belt_MutableMap.reduce,
          make: make,
          toArray: Belt_MutableMap.toArray
        };
}

var $$Map = {
  Make: Make,
  MakeMutable: MakeMutable
};

var anonymous_encode = Spice.stringToJson;

var anonymous_decode = Spice.stringFromJson;

var connected_encode = Spice.stringToJson;

var connected_decode = Spice.stringFromJson;

function t_encode$2(v) {
  if (typeof v === "number") {
    return ["Disconnected"];
  } else if (v.TAG === /* Anonymous */0) {
    return [
            "Anonymous",
            Spice.stringToJson(v._0)
          ];
  } else {
    return [
            "Connected",
            Spice.stringToJson(v._0)
          ];
  }
}

function t_decode$2(v) {
  var json_arr = Js_json.classify(v);
  if (typeof json_arr === "number") {
    return Spice.error(undefined, "Not a variant", v);
  }
  if (json_arr.TAG !== /* JSONArray */3) {
    return Spice.error(undefined, "Not a variant", v);
  }
  var json_arr$1 = json_arr._0;
  if (json_arr$1.length === 0) {
    return Spice.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = Js_array.map(Js_json.classify, json_arr$1);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Anonymous" :
          if (tagged.length !== 2) {
            return Spice.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Spice.stringFromJson(Belt_Array.getExn(json_arr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Anonymous */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "Connected" :
          if (tagged.length !== 2) {
            return Spice.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Spice.stringFromJson(Belt_Array.getExn(json_arr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Connected */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "Disconnected" :
          if (tagged.length !== 1) {
            return Spice.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Disconnected */0
                  };
          }
      default:
        
    }
  }
  return Spice.error(undefined, "Invalid variant constructor", Belt_Array.getExn(json_arr$1, 0));
}

function make$1(str) {
  if (str === "") {
    return /* Disconnected */0;
  } else if (Js_string.includes("anonymous_", str)) {
    return {
            TAG: /* Anonymous */0,
            _0: str
          };
  } else {
    return {
            TAG: /* Connected */1,
            _0: str
          };
  }
}

function anonymousToString(anonymous) {
  return anonymous;
}

function connectedToString(connected) {
  return connected;
}

function toString$1(t) {
  if (typeof t === "number") {
    return ;
  } else {
    return t._0;
  }
}

function getAnonymousToken(t) {
  if (typeof t === "number" || t.TAG !== /* Anonymous */0) {
    return ;
  } else {
    return t._0;
  }
}

var Token_anonymous = {
  TAG: /* Anonymous */0,
  _0: "anonymous_myToken"
};

var Token_connected = {
  TAG: /* Connected */1,
  _0: "myTokenconnected"
};

var Token = {
  anonymous_encode: anonymous_encode,
  anonymous_decode: anonymous_decode,
  connected_encode: connected_encode,
  connected_decode: connected_decode,
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  make: make$1,
  anonymousToString: anonymousToString,
  connectedToString: connectedToString,
  toString: toString$1,
  getAnonymousToken: getAnonymousToken,
  anonymous: Token_anonymous,
  connected: Token_connected,
  disconnected: /* Disconnected */0
};

var t_encode$3 = Spice.stringToJson;

var t_decode$3 = Spice.stringFromJson;

function toString$2(t) {
  return t.toLowerCase();
}

function make$2(value) {
  if (Type_Pattern.make(/* Email */0).test(value)) {
    return value;
  }
  
}

var Email = {
  t_encode: t_encode$3,
  t_decode: t_decode$3,
  toString: toString$2,
  make: make$2
};

var User = {
  Token: Token,
  Email: Email
};

var Id_toString = String_toString;

var Id_make = String_make;

var Id = {
  t_encode: t_encode,
  t_decode: t_decode,
  toString: Id_toString,
  empty: empty,
  make: Id_make,
  makeFromNullable: makeFromNullable,
  makeFromNullableOrEmpty: makeFromNullableOrEmpty
};

var Zone = {
  Id: Id
};

var Title_toString = String_toString;

var Title_make = String_make;

var Title = {
  t_encode: t_encode,
  t_decode: t_decode,
  toString: Title_toString,
  empty: empty,
  make: Title_make,
  makeFromNullable: makeFromNullable,
  makeFromNullableOrEmpty: makeFromNullableOrEmpty
};

var Subtitle_toString = String_toString;

var Subtitle_make = String_make;

var Subtitle = {
  t_encode: t_encode,
  t_decode: t_decode,
  toString: Subtitle_toString,
  empty: empty,
  make: Subtitle_make,
  makeFromNullable: makeFromNullable,
  makeFromNullableOrEmpty: makeFromNullableOrEmpty
};

var Description_toString = String_toString;

var Description_make = String_make;

var Description = {
  t_encode: t_encode,
  t_decode: t_decode,
  toString: Description_toString,
  empty: empty,
  make: Description_make,
  makeFromNullable: makeFromNullable,
  makeFromNullableOrEmpty: makeFromNullableOrEmpty
};

var Id_toString$1 = String_toString;

var Id_make$1 = String_make;

var Id$1 = {
  t_encode: t_encode,
  t_decode: t_decode,
  toString: Id_toString$1,
  empty: empty,
  make: Id_make$1,
  makeFromNullable: makeFromNullable,
  makeFromNullableOrEmpty: makeFromNullableOrEmpty
};

var DsId_toString = String_toString;

var DsId_make = String_make;

var DsId = {
  t_encode: t_encode,
  t_decode: t_decode,
  toString: DsId_toString,
  empty: empty,
  make: DsId_make,
  makeFromNullable: makeFromNullable,
  makeFromNullableOrEmpty: makeFromNullableOrEmpty
};

var BroadcastDate_toString = String_toString;

var BroadcastDate_make = String_make;

var BroadcastDate = {
  t_encode: t_encode,
  t_decode: t_decode,
  toString: BroadcastDate_toString,
  empty: empty,
  make: BroadcastDate_make,
  makeFromNullable: makeFromNullable,
  makeFromNullableOrEmpty: makeFromNullableOrEmpty
};

var Key_toString = String_toString;

var Key_make = String_make;

var Key = {
  t_encode: t_encode,
  t_decode: t_decode,
  toString: Key_toString,
  empty: empty,
  make: Key_make,
  makeFromNullable: makeFromNullable,
  makeFromNullableOrEmpty: makeFromNullableOrEmpty
};

var Label_toString = String_toString;

var Label_make = String_make;

var Label = {
  t_encode: t_encode,
  t_decode: t_decode,
  toString: Label_toString,
  empty: empty,
  make: Label_make,
  makeFromNullable: makeFromNullable,
  makeFromNullableOrEmpty: makeFromNullableOrEmpty
};

var Geoblocking = {
  Label: Label
};

var DurationLabel_toString = String_toString;

var DurationLabel_make = String_make;

var DurationLabel = {
  t_encode: t_encode,
  t_decode: t_decode,
  toString: DurationLabel_toString,
  empty: empty,
  make: DurationLabel_make,
  makeFromNullable: makeFromNullable,
  makeFromNullableOrEmpty: makeFromNullableOrEmpty
};

var Teaser = {
  Title: Title,
  Subtitle: Subtitle,
  Description: Description,
  Id: Id$1,
  DsId: DsId,
  BroadcastDate: BroadcastDate,
  Key: Key,
  Geoblocking: Geoblocking,
  DurationLabel: DurationLabel
};

var Id_toString$2 = String_toString;

var Id_make$2 = String_make;

var Id$2 = {
  t_encode: t_encode,
  t_decode: t_decode,
  toString: Id_toString$2,
  empty: empty,
  make: Id_make$2,
  makeFromNullable: makeFromNullable,
  makeFromNullableOrEmpty: makeFromNullableOrEmpty
};

var Clip_toString = String_toString;

var Clip_make = String_make;

var Clip = {
  t_encode: t_encode,
  t_decode: t_decode,
  toString: Clip_toString,
  empty: empty,
  make: Clip_make,
  makeFromNullable: makeFromNullable,
  makeFromNullableOrEmpty: makeFromNullableOrEmpty
};

var Trailer_toString = String_toString;

var Trailer_make = String_make;

var Trailer = {
  t_encode: t_encode,
  t_decode: t_decode,
  toString: Trailer_toString,
  empty: empty,
  make: Trailer_make,
  makeFromNullable: makeFromNullable,
  makeFromNullableOrEmpty: makeFromNullableOrEmpty
};

var Label_toString$1 = String_toString;

var Label_make$1 = String_make;

var Label$1 = {
  t_encode: t_encode,
  t_decode: t_decode,
  toString: Label_toString$1,
  empty: empty,
  make: Label_make$1,
  makeFromNullable: makeFromNullable,
  makeFromNullableOrEmpty: makeFromNullableOrEmpty
};

var Url_toString = String_toString;

var Url_make = String_make;

var Url = {
  t_encode: t_encode,
  t_decode: t_decode,
  toString: Url_toString,
  empty: empty,
  make: Url_make,
  makeFromNullable: makeFromNullable,
  makeFromNullableOrEmpty: makeFromNullableOrEmpty
};

var Genre = {
  Label: Label$1,
  Url: Url
};

var FirstBroadcastDate_toString = String_toString;

var FirstBroadcastDate_make = String_make;

var FirstBroadcastDate = {
  t_encode: t_encode,
  t_decode: t_decode,
  toString: FirstBroadcastDate_toString,
  empty: empty,
  make: FirstBroadcastDate_make,
  makeFromNullable: makeFromNullable,
  makeFromNullableOrEmpty: makeFromNullableOrEmpty
};

function makeFromTrailer(trailer) {
  return trailer;
}

function makeFromClip(clip) {
  return clip;
}

var Video_toString = String_toString;

var Video_make = String_make;

var Video = {
  t_encode: t_encode,
  t_decode: t_decode,
  toString: Video_toString,
  empty: empty,
  make: Video_make,
  makeFromNullable: makeFromNullable,
  makeFromNullableOrEmpty: makeFromNullableOrEmpty,
  makeFromTrailer: makeFromTrailer,
  makeFromClip: makeFromClip
};

var Program = {
  Id: Id$2,
  Clip: Clip,
  Trailer: Trailer,
  Genre: Genre,
  FirstBroadcastDate: FirstBroadcastDate,
  Video: Video
};

var CallToAction_toString = String_toString;

var CallToAction_make = String_make;

var CallToAction = {
  t_encode: t_encode,
  t_decode: t_decode,
  toString: CallToAction_toString,
  empty: empty,
  make: CallToAction_make,
  makeFromNullable: makeFromNullable,
  makeFromNullableOrEmpty: makeFromNullableOrEmpty
};

var toString$3 = String_toString;

function toTypeUrl(t) {
  return Type_Url.TrackingPixel.make(Curry._1(toString$3, t));
}

var TrackingPixel_make = String_make;

var TrackingPixel = {
  t_encode: t_encode,
  t_decode: t_decode,
  toString: toString$3,
  empty: empty,
  make: TrackingPixel_make,
  makeFromNullable: makeFromNullable,
  makeFromNullableOrEmpty: makeFromNullableOrEmpty,
  toTypeUrl: toTypeUrl
};

var Href_toString = String_toString;

var Href_make = String_make;

var Href = {
  t_encode: t_encode,
  t_decode: t_decode,
  toString: Href_toString,
  empty: empty,
  make: Href_make,
  makeFromNullable: makeFromNullable,
  makeFromNullableOrEmpty: makeFromNullableOrEmpty
};

var Label_toString$2 = String_toString;

var Label_make$2 = String_make;

var Label$2 = {
  t_encode: t_encode,
  t_decode: t_decode,
  toString: Label_toString$2,
  empty: empty,
  make: Label_make$2,
  makeFromNullable: makeFromNullable,
  makeFromNullableOrEmpty: makeFromNullableOrEmpty
};

var Value_toString = String_toString;

var Value_make = String_make;

var Value = {
  t_encode: t_encode,
  t_decode: t_decode,
  toString: Value_toString,
  empty: empty,
  make: Value_make,
  makeFromNullable: makeFromNullable,
  makeFromNullableOrEmpty: makeFromNullableOrEmpty
};

var Credit = {
  Label: Label$2,
  Value: Value
};

var Success_toString = String_toString;

var Success_make = String_make;

var Success = {
  t_encode: t_encode,
  t_decode: t_decode,
  toString: Success_toString,
  empty: empty,
  make: Success_make,
  makeFromNullable: makeFromNullable,
  makeFromNullableOrEmpty: makeFromNullableOrEmpty
};

var Error_toString = String_toString;

var Error_make = String_make;

var $$Error = {
  t_encode: t_encode,
  t_decode: t_decode,
  toString: Error_toString,
  empty: empty,
  make: Error_make,
  makeFromNullable: makeFromNullable,
  makeFromNullableOrEmpty: makeFromNullableOrEmpty
};

var SubscribeToNewsletter = {
  Success: Success,
  $$Error: $$Error
};

function addPath(cdnUrl, path) {
  return cdnUrl + path;
}

var CdnUrl_toString = String_toString;

var CdnUrl_make = String_make;

var CdnUrl = {
  t_encode: t_encode,
  t_decode: t_decode,
  toString: CdnUrl_toString,
  empty: empty,
  make: CdnUrl_make,
  makeFromNullable: makeFromNullable,
  makeFromNullableOrEmpty: makeFromNullableOrEmpty,
  addPath: addPath
};

var Id_toString$3 = String_toString;

var Id_make$3 = String_make;

var Id$3 = {
  t_encode: t_encode,
  t_decode: t_decode,
  toString: Id_toString$3,
  empty: empty,
  make: Id_make$3,
  makeFromNullable: makeFromNullable,
  makeFromNullableOrEmpty: makeFromNullableOrEmpty
};

var Source_toString = String_toString;

var Source_make = String_make;

var Source = {
  t_encode: t_encode,
  t_decode: t_decode,
  toString: Source_toString,
  empty: empty,
  make: Source_make,
  makeFromNullable: makeFromNullable,
  makeFromNullableOrEmpty: makeFromNullableOrEmpty
};

var Video$1 = {
  Id: Id$3,
  Source: Source
};

var Title_toString$1 = String_toString;

var Title_make$1 = String_make;

var Title$1 = {
  t_encode: t_encode,
  t_decode: t_decode,
  toString: Title_toString$1,
  empty: empty,
  make: Title_make$1,
  makeFromNullable: makeFromNullable,
  makeFromNullableOrEmpty: makeFromNullableOrEmpty
};

var Label_toString$3 = String_toString;

var Label_make$3 = String_make;

var Label$3 = {
  t_encode: t_encode,
  t_decode: t_decode,
  toString: Label_toString$3,
  empty: empty,
  make: Label_make$3,
  makeFromNullable: makeFromNullable,
  makeFromNullableOrEmpty: makeFromNullableOrEmpty
};

var Footer = {
  Title: Title$1,
  Label: Label$3
};

var PlayStoreUrl_toString = String_toString;

var PlayStoreUrl_make = String_make;

var PlayStoreUrl = {
  t_encode: t_encode,
  t_decode: t_decode,
  toString: PlayStoreUrl_toString,
  empty: empty,
  make: PlayStoreUrl_make,
  makeFromNullable: makeFromNullable,
  makeFromNullableOrEmpty: makeFromNullableOrEmpty
};

var AppStoreUrl_toString = String_toString;

var AppStoreUrl_make = String_make;

var AppStoreUrl = {
  t_encode: t_encode,
  t_decode: t_decode,
  toString: AppStoreUrl_toString,
  empty: empty,
  make: AppStoreUrl_make,
  makeFromNullable: makeFromNullable,
  makeFromNullableOrEmpty: makeFromNullableOrEmpty
};

var AppGalleryUrl_toString = String_toString;

var AppGalleryUrl_make = String_make;

var AppGalleryUrl = {
  t_encode: t_encode,
  t_decode: t_decode,
  toString: AppGalleryUrl_toString,
  empty: empty,
  make: AppGalleryUrl_make,
  makeFromNullable: makeFromNullable,
  makeFromNullableOrEmpty: makeFromNullableOrEmpty
};

var Notification_toString = String_toString;

var Notification_make = String_make;

var $$Notification = {
  t_encode: t_encode,
  t_decode: t_decode,
  toString: Notification_toString,
  empty: empty,
  make: Notification_make,
  makeFromNullable: makeFromNullable,
  makeFromNullableOrEmpty: makeFromNullableOrEmpty
};

exports.$$String = $$String;
exports.NotEmpty = NotEmpty;
exports.$$Map = $$Map;
exports.User = User;
exports.Zone = Zone;
exports.Teaser = Teaser;
exports.Program = Program;
exports.CallToAction = CallToAction;
exports.TrackingPixel = TrackingPixel;
exports.Href = Href;
exports.Credit = Credit;
exports.SubscribeToNewsletter = SubscribeToNewsletter;
exports.CdnUrl = CdnUrl;
exports.Video = Video$1;
exports.Footer = Footer;
exports.PlayStoreUrl = PlayStoreUrl;
exports.AppStoreUrl = AppStoreUrl;
exports.AppGalleryUrl = AppGalleryUrl;
exports.$$Notification = $$Notification;
/* No side effect */
